// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"53619bef","821":"30e9f330"}[chunkId] + ".chunk.js";
};